import { createAction } from 'redux-act';

// eslint-disable-next-line import/prefer-default-export
export const ADD_UPLOAD = createAction('Add an upload');
export const REMOVE_UPLOAD = createAction('Remove an upload');
export const UPDATE_UPLOAD = createAction('Edit an upload');
export const CLEAR_UPLOADS = createAction('Clearing uploads');
